import { Component, Input, OnInit } from "@angular/core";
import { AdvisorTypeEnum } from "../../../../models/Advisor";
import { AdvisorEntity } from "../../../../entities/advisor.entity";

@Component({
    selector: 'tr-advisor-profile',
    templateUrl: './advisor-profile.component.html',
    styleUrls: ['./advisor-profile.component.scss'],
})

export class AdvisorProfileComponent implements OnInit {
    @Input() public advisor: AdvisorEntity;
    public name?: string;
    public description?: string;

    ngOnInit(): void {
        if (this.advisor.type === AdvisorTypeEnum.POTENTIAL) {
            this.name = this.advisor.typeDescription;
            this.description = this.advisor.name;
        } else {
            this.name = this.advisor.name;
            this.description = this.advisor.typeDescription;
        }
    }
}